import React from 'react';
import TextInput from 'src/ui/library/TextInput';

class TextArea extends React.Component {
  getStyles = (type, height, width) => {
    switch (type) {
      default:
        return {
          textField: {
            height: height ? height : '100%',
            maxWidth: width ? width : '100%',
            border: '1px solid transparent',
          },
        };
    }
  };

  render() {
    const { styleType, height, width, rows, ...otherProps } = this.props;
    const styles = this.getStyles(styleType, height, width);
    return <TextInput multiline rows={rows ? rows : '4'} useEllipsisLabel="true" styles={styles} {...otherProps} />;
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/ui/library/TextArea/TextArea.js